export const TITLES = ['Mr', 'Ms', 'Mrs', 'Miss', 'Mx', 'Dr', 'Rev', 'Other'];
export const ENROLLMENT_YES = 'enrollmentYes';
export const ENROLLMENT_NO = 'enrollmentNo';
